// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1FVwz","col":"Table_col__2RKUF","fulfillmentStatus":"Table_fulfillmentStatus__2nOMt","emailCol":"Table_emailCol__9cPCS"};